// Ticket
export const RESET_TICKET = 'RESET_TICKET';

export const UPDATE_TICKET_LIST = 'UPDATE_TICKET_LIST';



// WEBPACK FOOTER //
// ./src/actions/ticket-actions.js